// Feature flags for controlling app behavior during development/beta
export const featureFlags = {
  // Project limit enforcement - set to true to require subscriptions
  PROJECT_LIMITS_ENABLED: true,
  
  // Payment processing - controls payment availability
  // When false: Only admin/mainAdmin users can access payment buttons (for testing)
  // When true: All users can access payment functionality (production ready)
  PAYMENTS_LIVE: true,
  
  // Add more feature flags as needed
  // AI_FEATURES_ENABLED: true,
  // ANALYTICS_ENABLED: true,
};

export default featureFlags;
